module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-numeric-up-alt-8e5132a5.svg";